module.exports = __webpack_public_path__ + "img/spacecoin.8668a168.png";